/**
 * Authentication Context
 *
 * This module defines the React Context for authentication state management.
 * It provides a centralized way to access authentication state and methods
 * throughout the application without prop drilling.
 */

import { createContext } from 'react';
import { AuthContextType } from 'types/Auth.types';

/**
 * Authentication Context
 *
 * This context provides:
 * - Authentication state (isAuthenticated, loading)
 * - User information (user)
 * - Authentication methods (signIn, signOut)
 * - Error handling (error, solution)
 *
 * The default values represent the unauthenticated state with
 * loading in progress and empty implementation of auth methods.
 */
const AuthContext = createContext<AuthContextType>({
  // Authentication state
  isAuthenticated: false,
  loading: true,

  // User information
  user: null,

  // Authentication methods (empty implementations)
  signIn: async () => {},
  signOut: async () => {},

  // Error handling
  error: null,
  solution: null,
});

export default AuthContext;
